import script from "./PageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PageComponent.vue?vue&type=script&setup=true&lang=js"

import "./PageComponent.vue?vue&type=style&index=0&id=2f858b3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f858b3e"]])

export default __exports__